import { apiForPrivate } from '.';
import { TRUSTED_DRIVER_ENDPOINT } from '../../config/ap';

const apiDepartments = apiForPrivate.injectEndpoints({
    overrideExisting: true,
    endpoints: build => ({
        getDepartmentClients: build.query({
            query: (params) => ({
                url: `${TRUSTED_DRIVER_ENDPOINT.DEPARTMENT_CLIENTS}`,
                params,
            })
        }),
        addDepartmentClient: build.mutation({
            query: (payload) => ({
                url: `${TRUSTED_DRIVER_ENDPOINT.DEPARTMENT_CLIENTS}`,
                method: 'POST',
                body: payload,
            }),
        }),
        deleteDepartmentClient: build.mutation({
            query: (id) => ({
                url: `${TRUSTED_DRIVER_ENDPOINT.DEPARTMENT_CLIENTS}/${id}`,
                method: 'DELETE',
            }),
        }),
    })
});

export const {
    useLazyGetDepartmentClientsQuery,
    useAddDepartmentClientMutation,
    useDeleteDepartmentClientMutation,
} = apiDepartments;
